import { createApp } from "vue";
import App from "./App.vue";
import ArcoVue from "@arco-design/web-vue";
import "@arco-design/web-vue/dist/arco.css";
import router from "./router";
import store from "./store";
import "@/plugins/axios";
import "@/access";
import "./assets/bytemd.css";
import "highlight.js/styles/a11y-light.min.css";

createApp(App).use(ArcoVue).use(store).use(router).mount("#app");
